import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import * as auth from "../Auth"
import {http_auth, REFRESH_TOKEN} from "../../../utility/Utils"
import {toast} from "react-toastify"

export const saveParam = createAsyncThunk('reportsDev/saveParam', async (data, {rejectWithValue, dispatch}) => {
    try {
        const response = await http_auth.post(`/admin/v1/report/param/save`, data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
    }
})

export const paramList = createAsyncThunk('reportsDev/paramList', async (reportId, {rejectWithValue, dispatch}) => {
    try {
        const response = await http_auth.post(`/admin/v1/report/param/list/${reportId}`, {})
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
    }
})


export const executeReport = createAsyncThunk('reportsDev/executeReport', async (data, {rejectWithValue, dispatch}) => {
    try {
        const response = await http_auth.post(`/admin/v1/report/execute`, data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
    }
})


export const runList = createAsyncThunk('reportsDev/runList', async (data, {rejectWithValue, dispatch}) => {
    try {
        const response = await http_auth.post(`/admin/v1/report/run/list`, data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
    }
})

export const reportsDevSlice = createSlice({
    name: 'reportsDev',
    initialState: {
        paramList: [],
        runList: [],
        execute: null,

        current_page: 0,
        count_item: 0,
        total_count: 0,
        isLoading: false
    },
    reducers: {},
    extraReducers: {
        [paramList.fulfilled](state, action) {
            state.paramList = action.payload?.data
            state.current_page = action.payload?.page
            state.count_item = action.payload?.count
            state.total_count = action.payload?.total_count
            state.isLoading = false
        },
        [paramList.pending](state) {
            state.isLoading = true
        },
        [paramList.rejected]: (state) => {
            toast.error("Error")
            state.isLoading = false
        },

        [runList.fulfilled](state, action) {
            state.runList = action.payload?.data
            state.current_page = action.payload?.page
            state.count_item = action.payload?.count
            state.total_count = action.payload?.total_count
            state.isLoading = false
        },
        [runList.pending](state) {
            state.isLoading = true
        },
        [runList.rejected]: (state) => {
            toast.error("Error")
            state.isLoading = false
        }
    }
})

export const {} = reportsDevSlice.actions

export default reportsDevSlice.reducer